import { Platform } from "react-native";

export enum EVENT_TYPES {
  BUTTON_LOGIN_DISMISS = "button_login_dismiss",
  BUTTON_LOGIN_PHONE = "button_login_phone",
  BUTTON_LOGIN_VERIFY = "button_login_verify",
  BUTTON_ADD_COUPON = "button_add_coupon",
  BUTTON_ADD_CREDIT = "button_add_credit",
  BUTTON_ADD_ADDRESS = "button_add_address",
  BUTTON_SELECT_ADDRESS = "button_select_address",
  BUTTON_SELECT_TIMESHEET = "button_select_timesheet",
  BUTTON_PAY_ORDER = "button_pay_order",
  // New
  COLLECTION_CANCEL = "collection_cancel",
  // Recommended by Google
  LOGIN = "login",
  SIGNUP = "sign_up",
  // Product views and interactions
  VIEW_ITEM = "view_item",
  VIEW_ITEM_LIST = "view_item_list",
  // Promotion views and interactions
  VIEW_PROMOTION = "view_promotion",
  SELECT_PROMOTION = "select_promotion",
  // Pre-purchase interactions
  ADD_TO_CART = "add_to_cart",
  REMOVE_FROM_CART = "remove_from_cart",
  VIEW_CART = "view_cart",
  // Purchases, checkouts
  BEGIN_CHECKOUT = "begin_checkout",
  PURCHASE = "purchase",
}

export let METRIX_EVENT_TYPES = {
  ACTION_SIGNIN: Platform.OS === "web" ? "uvjlp" : "yneju",
  ACTION_SIGNUP: Platform.OS === "web" ? "htyhg" : "qnpaf",
  ACTION_REVENUE_ON_DELIVERY: Platform.OS === "web" ? "bcqtv" : "azwzq",
  COLLECTION: Platform.OS === "web" ? "spuew" : "nfoch",
  COLLECTION_CANCEL: Platform.OS === "web" ? "iztrp" : "hhqae",
};

export interface MetrixEventData {
  isRevenue?: boolean;
  amount?: number;
  orderId?: string;
  [key: string]: any;
}

export interface ItemEvent {
  item_id: string;
  item_name: string;
  affiliation?: string;
  coupon?: string;
  currency?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price?: number;
  quantity?: number;
}

export interface ItemListEvent {
  item_list_id: string;
  item_list_name: string;
  items: ItemEvent[];
}
export interface CartEvent {
  currency: string;
  value: number;
  coupon?: string;
  items: ItemEvent[];
}

export interface PurchaseEvent {
  currency: string;
  transaction_id?: string;
  affiliation?: string;
  value: number;
  coupon?: string;
  shipping?: number;
  tax?: number;
  items: ItemEvent[];
}

export type PurchaseMetadataEvent = Omit<
  PurchaseEvent,
  "currency" | "items" | "value"
>;

export interface AddToCartEvent {
  currency: string;
  value: number;
  items: ItemEvent[];
}
